import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type EditLockState = {
	lockSocketConnected: boolean
	editLockModal: boolean
	warningLockModal: boolean
}

const initialState: EditLockState = {
	lockSocketConnected: false,
	editLockModal: false,
	warningLockModal: false,
}

export const editLockSlice = createSlice({
	name: 'editLock',
	initialState,
	reducers: {
		setLockSocketConnected: (state, { payload }: PayloadAction<boolean>) => {
			state.lockSocketConnected = payload
		},
		setEditLockModal: (state, { payload }: PayloadAction<boolean>) => {
			state.editLockModal = payload
		},
		setWarningLockModal: (state, { payload }: PayloadAction<boolean>) => {
			if (payload) {
				state.editLockModal = false
			}
			state.warningLockModal = payload
		},
	},
})

export const { setLockSocketConnected, setEditLockModal, setWarningLockModal } =
	editLockSlice.actions

export const editLock = editLockSlice.reducer
